import { useGet } from '../../HttpClient';
import { AccountTreatmentIndicatorModel } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryClient } from '@tanstack/react-query';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

export function useAccountTreatmentIndicators() {
  const get = useGet(true, "tms");
  const getAccountTreatmentIndicators = (): Promise<AccountTreatmentIndicatorModel[]> =>
      get(`${tenantHierarchyBaseUrl}/account-treatment-indicators`);
  return useQueryWithErrorHandling({
    queryKey: ['get-account-treatment-indicators'],
    queryFn: async () => await getAccountTreatmentIndicators(),
  });
}

export function useRefreshAccountTreatmentIndicators() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-account-treatment-indicators'] });
}
